"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _go = _interopRequireDefault(require("highlight.js/lib/languages/go"));

var _default = _go.default;
exports.default = _default;